/*  ========================================================================
    # Components - Trailer Lightbox
    ========================================================================  */
import React from 'react';
import LazyImage from './LazyImage';
import LazySource from './LazySource';
import PropTypes from 'prop-types';
import useLocalization from '../hooks/useLocalization';
import { breakpoints } from '../helpers/breakpoints';
import useTranslation from '../hooks/useTranslation';

const TrailerPreview = ({ trailerThumbnail, hideLabel = false, onClick }) => {
  const _ = useTranslation();

  // Icons
  const local = useLocalization();
  const iconPlay = `${local('svgSprite')}#play`;

  return (
    <>
      <button
        className={`c-trailer-preview ${hideLabel ? 'c-trailer-preview--no-label' : ''}`}
        onClick={onClick}
        aria-label={_('trailer_play')}
      >
        {!hideLabel && <div className='c-trailer-preview__label c-label'>{_('trailer_play')}</div>}
        <div className='c-trailer-preview__button c-button c-button--white c-button--icon c-button--icon-black'>
          <svg viewBox='0 0 200 200'>
            <use href={iconPlay}></use>
          </svg>
        </div>
        <LazyImage
          figureClass='c-trailer-preview__image-wrapper'
          imageClass='c-trailer-preview__image'
          defaultUrl={trailerThumbnail['sizes']['medium_large']}
          placeholderUrl={trailerThumbnail['sizes']['placeholder']}
          alt={trailerThumbnail['alt']}
          preload={hideLabel}
        >
          <LazySource srcSet={trailerThumbnail['sizes']['1536x1536']} mediaMin={breakpoints.lg} />
          <LazySource srcSet={trailerThumbnail['sizes']['large']} mediaMin={breakpoints.md} />
          <LazySource
            srcSet={trailerThumbnail['sizes']['medium_large']}
            mediaMin={breakpoints.sm}
          />
        </LazyImage>
      </button>
    </>
  );
};

TrailerPreview.propTypes = {
  trailerThumbnail: PropTypes.object,
  hideLabel: PropTypes.bool,
  onClick: PropTypes.func
};

export default TrailerPreview;
